// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3oAQz","list":"BalanceDue_list__3Y5fg","listRow":"BalanceDue_listRow__avPhW","total":"BalanceDue_total__1JADz"};